export default __webpack_public_path__ + "static/media/d24.1ed0f24f.jpeg";